var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverviewDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#00CC99",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5938 13.1719H13.4062C12.6309 13.1719 12 13.8028 12 14.5781V28.5469C12 29.3222 12.6309 29.9531 13.4062 29.9531H34.5938C35.3691 29.9531 36 29.3222 36 28.5469V14.5781C36 13.8028 35.3691 13.1719 34.5938 13.1719Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.4219H27.7031V31.3594H20.2969V33.4219H16.5C16.1119 33.4219 15.7969 33.7369 15.7969 34.125C15.7969 34.5131 16.1119 34.8281 16.5 34.8281H31.5C31.8881 34.8281 32.2031 34.5131 32.2031 34.125C32.2031 33.7369 31.8881 33.4219 31.5 33.4219Z",
    fill: "#00CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewDevices);
export default __webpack_public_path__ + "static/media/ICON_OVERVIEW_DEVICES.57745009a562cf7f67104a3324c7a089.svg";
export { ForwardRef as ReactComponent };